import { render, staticRenderFns } from "./UserAccountMenu.vue?vue&type=template&id=f5472400"
import script from "./UserAccountMenu.vue?vue&type=script&lang=ts"
export * from "./UserAccountMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports